import axios from 'axios';
import React from 'react';

import { Container, Row, Col, Form, Button, Table, Spinner } from 'react-bootstrap';

import NumberFormat from 'react-number-format';


class BenefitCalculator extends React.Component {
    tableRows = [
        {
            key: "monthly",
            title: "TITLE_MONTHLY",
        },
        {
            key: "hybrid",
            title: "TITLE_HYBRID",
        },
        {
            key: "pluginHybrid",
            title: "TITLE_PLUGINHYBRID",
        },
        {
            key: "electric",
            title: "TITLE_ELECTRIC",
        }
    ]
    constructor(props) {
        super(props);
        this.t = props.t;
        const now = new Date();
        this.state = {
            benefitYears: [],
            regYear: now.getFullYear(),
            benefitYear: now.getFullYear(),
            regYearMax: now.getFullYear(),
            regYearMin: now.getFullYear()-10,
            lastAccessoryPurchaseYear: now.getFullYear(),
            result: null,
            calculating: false,
        };
        if(document.location.href.startsWith('http://localhost')) {
            this.apiUrl = 'http://localhost:3001/';
        }
        else if(document.location.href.startsWith('https://sectoportaldev')) { 
            this.apiUrl = 'https://internal-api.azurewebsites.net/';
        }
        else {
            this.apiUrl = 'https://internal-api.secto.systems/';
        }
    }
    componentDidMount() {
        this.getYears();
    }
    getYears = () => {
        axios({
            method: 'get',
            url: this.apiUrl+'calculations/car-benefit/benefit-years'
        }).then(res => {
            const maxBenefitYear = res.data.reduce((prev,cur) => (cur>prev ? cur : prev) ,0);
            this.setState({
                benefitYears: res.data.sort(),
                benefitYear: maxBenefitYear
            })
        }).catch(ex => {
            console.error(ex);
        })
    }
    getBenefit = () => {
        this.setState({
            calculating: true
        });
        const { regYear, benefitYear, listPrice, accessoriesPrice, lastAccessoryPurchaseYear } = this.state;
        axios({
            method: 'get',
            url: this.apiUrl+'calculations/car-benefit',
            params: {
                listPrice,
                benefitYear,
                regYear,
                accessoriesPrice,
                lastAccessoryPurchaseYear,
            }
        }).then(res => {
            this.setState({
                result: res.data,
                calculating: false
            })
        }).catch(ex => {
            console.error(ex);
            this.setState({
                calculating: false
            })
        })
    }
    onValueChange = (ev) => {
        const val = ev.target.value.replace(",",".").replace(" ","");
        if(val!=="" && isNaN(+val)) {
            return;
        }
        this.setState({
            [ev.target.name]: val
        });
    }
    normalizeValue = (ev) => {
        var val = ev.target.value.replace(",",".").replace(" ","");
        if(val==="" && isNaN(+val)) {
            return;
        }
        const dec = +val;
        if(ev.target.min && dec<ev.target.min) {
            val = ev.target.min;
        }
        else if(ev.target.max && dec>ev.target.max) {
            val = ev.target.max;
        }
        val = String(val);
        if(ev.target.step)
        {
            if(val.indexOf(".")>-1) {
                const parts = val.split(".");
                if(parts[1].length<2) {
                    val = parts[0]+"."+parts[1].padEnd(2,"0");
                }
            }
            else {
                val += ".00";
            }
        }
        this.setState({
            [ev.target.name]: val.replace(".",",")
        });
    }
    setNumberValue = (field,val) => {
        this.setState(prevState => ({
            [field]: val.floatValue,
        }));
    }
    clearResult = () => {
        this.setState({
            result: null
        });
    }
    render() {
        const { benefitYears, regYear, regYearMin, regYearMax, benefitYear, listPrice, accessoriesPrice, lastAccessoryPurchaseYear, result, calculating } = this.state;
        return (
            <div className="benefit-calculator-container">
                <Form>
                    <Container>
                    {
                        result ? (
                            <Row>
                                <Col>
                                    <Button
                                        variant="link"
                                        onClick={this.clearResult}
                                    >
                                        {this.t('RETURN')}
                                    </Button>
                                </Col>
                            </Row>
                        ) : (
                            <div>
                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>{this.t('BENEFIT_YEAR')}</Form.Label>
                                        <Form.Select
                                            name="benefitYear"
                                            value={benefitYear}
                                            onChange={this.onValueChange}
                                        >
                                            {
                                                benefitYears.map((year,index) => <option value={year} key={index}>{year}</option>)
                                            }
                                        </Form.Select>

                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>{this.t('REGISTRATION_YEAR')}</Form.Label>
                                        <NumberFormat
                                            name="regYear"
                                            customInput={Form.Control}
                                            value={regYear}
                                            maxLength={4} 
                                            min={regYearMin} 
                                            max={regYearMax} 
                                            onValueChange={(val) => this.setNumberValue('regYear',val)}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>{this.t('LISTPRICE')}</Form.Label>
                                        <NumberFormat
                                            name="listPrice"
                                            customInput={Form.Control}
                                            value={listPrice}
                                            maxLength={12} 
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={' '}
                                            decimalSeparator={','}
                                            placeholder={'0,00'}
                                            onValueChange={(val) => this.setNumberValue('listPrice',val)}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>{this.t('ACCESSORIES_PRICE')}</Form.Label>
                                        <NumberFormat
                                            name="accessoriesPrice"
                                            customInput={Form.Control}
                                            value={accessoriesPrice}
                                            maxLength={11} 
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={' '}
                                            decimalSeparator={','}
                                            placeholder={'0,00'}
                                            onValueChange={(val) => this.setNumberValue('accessoriesPrice',val)}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>{this.t('LAST_ACCESSORY_PURCHASE_DATE')}</Form.Label>
                                        <NumberFormat
                                            name="lastAccessoryPurchaseYear"
                                            customInput={Form.Control}
                                            value={lastAccessoryPurchaseYear}
                                            maxLength={4} 
                                            min={regYearMin} 
                                            max={regYearMax} 
                                            onValueChange={(val) => this.setNumberValue('lastAccessoryPurchaseYear',val)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="pt-3">
                                    <Button
                                        variant="primary"
                                        onClick={this.getBenefit}
                                        >{this.t('SUBMIT')}</Button>
                                </Col>
                            </Row>
                            </div>
                        )
                    }
                    {
                        result ? (
                            <div>
                                <Row>
                                    <Col className="mt-5">
                                        <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <div>{this.t('LISTPRICE')} <NumberFormat displayType="text" thousandSeparator=' ' decimalScale={0} value={result.listPrice} /> €</div>
                                                        <div>{this.t('ACCESSORIES_PRICE')} <NumberFormat displayType="text" thousandSeparator=' ' decimalScale={0} value={result.accessoriesPrice} /> €</div>
                                                        <div>{this.t('AGEGROUP')} {result.ageGroup}</div>
                                                    </th>
                                                    <th>
                                                        <div>{this.t('BENEFIT_FREE')}</div>
                                                        <div className="benefit-reduction">{this.t('BENEFIT_REDUCTION')}</div>
                                                    </th>
                                                    <th>
                                                        <div>{this.t('BENEFIT_LIMITED')}</div>
                                                        <div className="benefit-reduction">{this.t('BENEFIT_REDUCTION')}</div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.tableRows.map(row => (
                                                        <tr key={row.key} className={`benefit-table-${row.key}`}>
                                                            <td>
                                                                <div>{this.t(row.title)}</div>
                                                                {
                                                                    row.key.toLowerCase().indexOf('hybrid')>-1 ? (
                                                                        <div>
                                                                            <small>{this.t(`${row.title}_CO2`)}</small>
                                                                        </div>
                                                                    ) : ""
                                                                }
                                                            </td>
                                                            <td className="benefit-value">
                                                                {result[`${row.key}FreeBenefit`]} €
                                                                {
                                                                    result[`${row.key}ReductionFreeBenefit`] ? <span className="benefit-reduction"> ({result[`${row.key}ReductionFreeBenefit`]} €)</span> : ""
                                                                }
                                                            </td>
                                                            <td className="benefit-value">
                                                                {result[`${row.key}LimitedBenefit`]} €
                                                                {
                                                                    result[`${row.key}ReductionLimitedBenefit`] ? <span className="benefit-reduction"> ({result[`${row.key}ReductionLimitedBenefit`]} €)</span> : ""
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))   
                                                }
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <p className="benefit-explanation">
                                            {this.t('BENEFIT_EXPLANATION')} <a href={this.t('READ_MORE_LINK')} target="_blank" rel="noreferrer">{this.t('READ_MORE')}</a>
                                        </p>
                                    </Col>
                                </Row>
                            </div>
                        ) : (calculating ? <Spinner animation="border" /> : "")
                    }
                    </Container>
                </Form>
            </div>
       )
    }
}
export default BenefitCalculator;